import { useEffect, useState } from "react";
import { Container, Typography, Paper, Box, Grid, Avatar, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { EventAvailable, HowToReg } from "@mui/icons-material";
import { Form, Input, Submit } from "../Form";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getEventInfo, singlePost } from "../../features/records/recordSlice";
import moment from 'moment';

const initialState = [{ nombre: '', tipo: ''}]

const userState = { id: '', codigo: '', nombre: '', tipo: 0, createdAt: new Date() }

const SinglePost = () => {
    const [data, setData] = useState(initialState);
    const [status, setStatus] = useState('idle');
    const [success, setSuccess] = useState(false);
    const [user, setUser] = useState(userState)
    const types = ['','👨🏻‍💻','👨🏻‍🎓','','👨🏻‍🏫','👨🏻‍💼']
    
    const { id } = useParams();
    const decoded = atob(id);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true })

    const onSubmit = values => {
        values['id'] = decoded;
        singlePost(dispatch, values, methods.setError, navigate, setSuccess, setUser);
    }

    useEffect(() => {
        if(status === 'idle') getEventInfo(dispatch, decoded, navigate, setData, setStatus)
    }, [navigate, id, decoded, dispatch, status])

    return(
        <Container component={Paper} maxWidth={'xs'} sx={{ p: '2em', mb: '2em' }}>
            { success ? 
            (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Avatar sx={{ backgroundColor: 'green' }}> <HowToReg /> </Avatar>
                    <Typography variant="h4" align="center">Bienvenido <br /> {types[user.tipo]}</Typography>
                    <Typography variant="h5" align="center" gutterBottom>{user.nombre}</Typography>
                    <Typography variant="h6" align="center" color={'primary'} gutterBottom>Tú asistencia al evento:</Typography>  
                    <Typography variant="body1" align="center" color={'gray'} gutterBottom>"{data[0].nombre}"</Typography>
                    <Typography variant="h6" align="center" color={'primary'} gutterBottom>ha sido registrada exitosamente.</Typography>  
                    <Typography variant="body2" align="center" color={'gray'} sx={{ mb: '1em' }}> Fecha y hora del registro: < br/> ✅ {moment(user.createdAt).format('LLLL')}</Typography>
                    <Button variant="outlined" color="primary" onClick={() => navigate('/')}>Ir a inicio</Button>
                </Box>
            )    
            : (<>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Avatar sx={{ backgroundColor: 'green' }}> <EventAvailable /> </Avatar>
                    <Typography variant="h6">{data[0].tipo}</Typography>
                    <Typography variant="h5" color={'primary'} align="center">{data[0].nombre}</Typography>
                    <Typography variant="body2" align="left" color={'gray'}>Escribe tu código para registrarte.</Typography>
                </Box>
                <Form methods={methods} onSubmit={onSubmit}>
                    <Grid container spacing={2}>
                        <Input name={'codigo'} min={7} max={9} regEx={/[0-9A-Z]/g} label={'Código'} />
                        <Submit title="Registrarme" />
                    </Grid>
                </Form>
            
            </>) }
        </Container>
    )
}

export default SinglePost;